import { TabTilePlaceholder } from './TabTilePlaceholder.jsx';

export const TabWithPlaceholder = ({ tiles, showStats, children }) => {
  if (tiles.length === 0) {
    return <TabTilePlaceholder showStats={showStats} />;
  }

  return children;
};
